// extracted by mini-css-extract-plugin
export default {"noteForm":"noteForm_noteForm__mdRee"};